import api from '../api'

const organizationApi = {
  // Get all organizations with pagination
  getOrganizations: (page: number = 1, pageSize: number = 20) => {
    return api.get('/admin/organizations', {
      params: { page, pageSize }
    })
  },

  // Get organization by ID
  getOrganizationById: (organizationId: string) => {
    return api.get(`/admin/organizations/${organizationId}`)
  },

  // Get organization statistics
  getOrganizationStats: () => {
    return api.get('/admin/organizations/stats')
  },

  // Search organizations
  searchOrganizations: (query: string) => {
    return api.get('/admin/organizations/search', {
      params: { q: query }
    })
  },

  // Create new organization
  createOrganization: (organizationData: any) => {
    return api.post('/admin/organizations', organizationData)
  },

  // Update organization
  updateOrganization: (organizationId: string, data: any) => {
    return api.put(`/admin/organizations/${organizationId}`, data)
  },

  // Delete organization
  deleteOrganization: (organizationId: string) => {
    return api.delete(`/admin/organizations/${organizationId}`)
  },

  // Activate organization
  activateOrganization: (organizationId: string) => {
    return api.post(`/admin/organizations/${organizationId}/activate`)
  },

  // Deactivate organization
  deactivateOrganization: (organizationId: string) => {
    return api.post(`/admin/organizations/${organizationId}/deactivate`)
  },

  // Get organization users
  getOrganizationUsers: (organizationId: string, page: number = 1, pageSize: number = 10) => {
    return api.get(`/admin/organizations/${organizationId}/users`, {
      params: { page, pageSize }
    })
  },

  // Add user to organization
  addUserToOrganization: (organizationId: string, userId: string, roleId: string) => {
    return api.post(`/admin/organizations/${organizationId}/users`, {
      userId,
      roleId
    })
  },

  // Remove user from organization
  removeUserFromOrganization: (organizationId: string, userId: string) => {
    return api.delete(`/admin/organizations/${organizationId}/users/${userId}`)
  },

  // Update user role in organization
  updateUserRole: (organizationId: string, userId: string, roleId: string) => {
    return api.put(`/admin/organizations/${organizationId}/users/${userId}/role`, {
      roleId
    })
  },

  // Get organization branches
  getOrganizationBranches: (organizationId: string) => {
    return api.get(`/admin/organizations/${organizationId}/branches`)
  },

  // Create organization branch
  createOrganizationBranch: (organizationId: string, branchData: any) => {
    return api.post(`/admin/organizations/${organizationId}/branches`, branchData)
  },

  // Update organization branch
  updateOrganizationBranch: (organizationId: string, branchId: string, data: any) => {
    return api.put(`/admin/organizations/${organizationId}/branches/${branchId}`, data)
  },

  // Delete organization branch
  deleteOrganizationBranch: (organizationId: string, branchId: string) => {
    return api.delete(`/admin/organizations/${organizationId}/branches/${branchId}`)
  },

  // Get organization settings
  getOrganizationSettings: (organizationId: string) => {
    return api.get(`/admin/organizations/${organizationId}/settings`)
  },

  // Update organization settings
  updateOrganizationSettings: (organizationId: string, settings: any) => {
    return api.put(`/admin/organizations/${organizationId}/settings`, settings)
  },
}

export default organizationApi